import { Taxon } from "src/app/domain/IBMR/IBMR-taxon"

export class TaxonSplitDTO {
    CustomName: string
    AnalyseCode: string
    DestinationTaxonList: Taxon[] = []
    Comment: string
}